import { IRiskOption } from "src/core/constants/options";

export const nonStandardCountryCodeMap: Record<string, string> = {
  // Codes non ISO courants (souvent vus dans les données sanctions/PEP)

  RUSS: "Russie",
  NOTK: "Non renseigné",
  NORK: "Corée du Nord",
  IRAN: "Iran",
  SYRI: "Syrie",
  SUDN: "Soudan",
  CUBA: "Cuba",
  VENE: "Venezuela",
  MYAN: "Myanmar (Birmanie)",

  // Parfois vus selon les fournisseurs
  UKRA: "Ukraine",
  BELA: "Biélorussie",
  HONG: "Hong Kong",
  MACA: "Macao",
  SRBS: "Serbie",
  KAZA: "Kazakhstan",
  PAKS: "Pakistan",
  AFGA: "Afghanistan",
  IRAQ: "Irak",
  LBYA: "Libye",

  // Codes à valeur technique
  XXXX: "Code inconnu",
  ZZXX: "Territoire non reconnu",
  XXAA: "Zone non définie",
};

/**
 * Trouve le label d'un pays dans la liste des pays.
 */
export const findCountryLabel = (code: string, countries: IRiskOption[]): string | undefined => {
  return countries.find((c) => c.value === code)?.label;
};
